// extracted by mini-css-extract-plugin
module.exports = {"Headline":"styles_Headline__CfYDm"};